window.onload = function() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function(position){
            console.log(`Latitude: ${position.coords.latitude}<br>Longitude: ${position.coords.longitude}`);
        }, function(error){
            console.error(error);
        });
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    };